import React, { useCallback, useEffect, useState } from "react";
import InputField from "../components/Input";
import Multiselect from "multiselect-react-dropdown";
import Select from "../components/CustomSelect";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import DropBox, { fileImage, fileListToBase64 } from "../components/DropBox";
import ImageGrid from "../components/ImageGrid";
import { TagBox, TagBoxItem } from "../components/TagBox/index";
import { Formik } from "formik";
import SelectComponent from "../components/CustomSearchSelect";
import { AddDeleteImage, EditDeleteImage, ProductImageUpload } from "../generatedRequest/product";
import { toast } from "react-toastify";
import CustomArrow from "../utils/CustomStyleComponent/ArrowComponent";
import CustomCrossButton from "../utils/CustomStyleComponent/CrossButtonComponent";
import CustomTooltip from "../utils/CustomStyleComponent/TooltipComponent";
import { toAbsoluteUrl } from "../_metronic/helpers";
import { title } from "process";
import { Value } from "sass";
import Button from "../components/Button";
import Badge from "../components/Badge";
import axios from "axios";
import "./Product.css";

type TproductFormProp = {
  errors: any;
  isSubmitting: boolean;
  touched: any;
  setFieldTouched: any;
  getFieldProps: Function;
  setFieldValue: Function;
  values: any;
  allRegions: any;
  allCategory: any;
  isEdit: boolean;
  isloading: boolean;
  handleScrapeProduct: Function;
  isScrapping: boolean;
  handleSearchParams: Function;
  products: any;
  setProductToScrape: any;
  handleSecondaryScrapeProduct: Function;
  setsecondarySourceToScrape: any;
  secondaryLoading: boolean;
  ternaryLoading: boolean;
  attributetobefetched: string;
  VerifyAttributeData: Function;
  fetchedValue: string;
  primarySourceData: any[];
  secondarySourceData: any[];
  chatGptData: any[];
  productToScrape: any;
  secondarySourceToScrape: any
};

const ProductForm = ({
  errors,
  isEdit,
  isSubmitting,
  touched,
  isloading,
  getFieldProps,
  setFieldValue,
  values,
  setFieldTouched,
  allRegions,
  allCategory,
  handleScrapeProduct,
  isScrapping,
  handleSearchParams,
  products,
  setProductToScrape,
  handleSecondaryScrapeProduct,
  setsecondarySourceToScrape,
  secondaryLoading,
  ternaryLoading,
  attributetobefetched,
  VerifyAttributeData,
  fetchedValue,
  primarySourceData,
  secondarySourceData,
  chatGptData,
  productToScrape,
  secondarySourceToScrape
}: TproductFormProp) => {

  const style = {
    multiselectContainer: {
      minheight: "44px",
      border: "1px solid var(--bs-gray-100)",

      // styles for the multiselect container
    },
    searchBox: {
      minheight: "44px",
      fontSize: "1.1rem",
      fontWeight: "500",

      // styles for the search wrapper
    },
  };
  const navigate = useNavigate();
  let defaultImages = [];

  if (values?.images) {
    defaultImages = values?.images.map((t: any) => {
      return {
        id: t.id,
        url: t.src,
        type: "uploaded",
        file: null,
      };
    });
  }



  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
  const [selectedFilesURL, setSelectedFilesURL] =
    useState<any[]>(defaultImages);

  const [selectedValues, setSelectedValues] = useState<any>({});

  useEffect(() => {
    const fn = () => {
      const updatedSelectedValues = { ...selectedValues };
      const supportedAttributes = values?.subcategory?.[0]?.supportedAttributes;
      const attributes = values?.attributes;
      if (
        supportedAttributes &&
        supportedAttributes.length > 0 &&
        attributes &&
        attributes.length > 0
      ) {
        for (const supportedAttribute of supportedAttributes) {
          const supportedAttributeName = supportedAttribute.attributeName;

          for (const attribute of attributes) {
            const attributeName = attribute.attributeName;
            if (supportedAttributeName === attributeName) {
              updatedSelectedValues[supportedAttribute._id] =
                supportedAttribute.supportedUnits.filter(
                  (data: any) => data?.name === attribute?.unit?.name
                )[0];
              break;
            }
          }
        }
      }

      setSelectedValues(updatedSelectedValues);
    };

    fn();
  }, [values.attributes, values.subcategory]);

  const handleImageUrlDelete = useCallback(
    (index: number) => {
      const fn = async function () {
        // let curRecord: any = selectedFilesURL[index];
        let curRecord: any = values.images[index];
        if (curRecord?.type === "uploaded") {
          // let res: any = await DeleteProductImage(resData._id, [curRecord.id])
          // if (res.data.status === false) {
          // setStatus(res.data.error)
          // } else {
          // let images = formik.values.images.filter((image: any, _index: number) => _index !== index)
          // formik.setFieldValue("images", images);
          // setSelectedFilesURL(selectedFilesURL.filter((image, _index) => _index !== index))
          // }
        } else {
          // let images = formik.values.images.filter((image: any, _index: number) => _index !== index)
          // formik.setFieldValue("images", images);
          setSelectedFilesURL(
            selectedFilesURL.filter((image, _index) => _index !== index)
          );
        }
      };
      fn();
    },
    [selectedFilesURL, setSelectedFilesURL, values]
  );

  const handleDropFiles = useCallback(
    (files: any[]) => {
      const fn = async function () {
        const res = await ProductImageUpload(files);
        if (res.data.status) {
          let images = res.data.data.productImagesURL;
          setFieldValue("productImages", images);
        } else {
          toast.error("Something went wrong");
        }
      };
      fn();
    },
    [selectedFilesURL, selectedFiles, values]
  );

  const handleDelete = async (index: number) => {
    try {
      const { _id, productImages } = values;
      const res = isEdit
        ? await EditDeleteImage(_id, productImages[index])
        : await AddDeleteImage(productImages[index]);

      if (res.data.status) {
        const temp = productImages;
        temp.splice(index, 1);
        setFieldValue("productImages", temp);
        toast.success("Image deleted succcessfully");
      } else {
        toast.error(res.data.message);
      }
    } catch (error: any) {
      console.error("Error during delete operation:", error);
      toast.error((error.response?.data?.message || error.message || "Unknown error"));
    } finally {
      // You can handle any cleanup here if needed, e.g., setLoading(false);
    }
  };

  const handleNewTag = (tagName: string) => {
    if (tagName) {
      const newTag: TagBoxItem = {
        name: tagName,
        id: Date.now(), // generate a unique ID for the new tag
      };
      setFieldValue("subcategory", [...values.subcategory, newTag]);
    }
    // add the new tag to the list of tags
  };

  const handleDeleteTag = (tag: TagBoxItem, index: number) => {
    const newTags = [...values.subcategory];
    newTags.splice(index, 1);
    setFieldValue("subcategory", newTags); // remove the tag at the specified index
  };

  const handleFirstSelectChange =
    (attributeId: any, unitIndex: any) => (e: any) => {

      // If blank option is selected, clear the unit
      if (e.target.value === "") {
        setSelectedValues((prevValues: any) => ({
          ...prevValues,
          [attributeId]: null, // Clear the selected unit
        }));

        // Also clear the unit and optionally the value in the attributes array
        const updatedAttributes = values.attributes.map((attribute: any) => {
          if (attribute.attributeName === values.subcategory[0].supportedAttributes.find(
            (attr: any) => attr._id === attributeId
          ).attributeName) {
            return {
              ...attribute,
              unit: null, // Clear the unit
              // Optionally clear the value as well:
              // value: "",
            };
          }
          return attribute;
        });

        setFieldValue("attributes", updatedAttributes);
        return; // Exit early
      }

      const selectedUnit = values.subcategory[0].supportedAttributes.find(
        (attribute: any) => attribute._id === attributeId
      ).supportedUnits[unitIndex];

      setSelectedValues((prevValues: any) => ({
        ...prevValues,
        [attributeId]: selectedUnit,
      }));
    };

  /* const handleDimensionsUnitChange = (attributeId: any, unitIndex: any, e: any) => {
    // First handle the normal unit change
    handleFirstSelectChange(attributeId, unitIndex)(e);

    // Check if this is a Dimensions group attribute
    const dimensionAttributes = ['Width', 'Depth', 'Height'];
    const currentAttribute = values.subcategory[0].supportedAttributes.find(
      (attr: any) => attr._id === attributeId
    );
    
    if (dimensionAttributes.includes(currentAttribute?.attributeName)) {
      // Get the selected unit
      const selectedUnit = values.subcategory[0].supportedAttributes.find(
        (attribute: any) => attribute._id === attributeId
      ).supportedUnits[unitIndex];
      
      // Find all dimension attributes
      const allDimensionAttributes = values.subcategory[0].supportedAttributes.filter(
        (attr: any) => dimensionAttributes.includes(attr.attributeName)
      );

      // Update selectedValues for all dimension attributes
      const updatedSelectedValues = { ...selectedValues };
      allDimensionAttributes.forEach((attr: any) => {
        updatedSelectedValues[attr._id] = selectedUnit;
      });
      setSelectedValues(updatedSelectedValues);
      
      console.log("Updated Selected Values:", values.attributes);
      // Update the form values for all dimension attributes
      const updatedAttributes = values.attributes.map((attribute: any) => {
        if (dimensionAttributes.includes(attribute.attributeName)) {
          return {
            ...attribute,
            unit: selectedUnit ? {
              _id: selectedUnit._id,
              name: selectedUnit.name,
            } : null,
          };
        }
        return attribute;
      });
      console.log(updatedAttributes);
      setFieldValue("attributes", updatedAttributes);
    }
  }; */

  /* const handleDimensionsUnitChange = (attributeId: any, unitIndex: any, e: any) => {
    // First handle the normal unit change
    handleFirstSelectChange(attributeId, unitIndex)(e);
  
    // Check if this is a Dimensions group attribute
    const dimensionAttributes = ['Width', 'Depth', 'Height'];
    const currentAttribute = values.subcategory[0].supportedAttributes.find(
      (attr: any) => attr._id === attributeId
    );
  
    if (currentAttribute && dimensionAttributes.includes(currentAttribute.attributeName)) {
      // Get the selected unit
      const selectedUnit = values.subcategory[0].supportedAttributes.find(
        (attribute: any) => attribute._id === attributeId
      ).supportedUnits[unitIndex];
  
      // Find all dimension attributes
      const allDimensionAttributes = values.subcategory[0].supportedAttributes.filter(
        (attr: any) => dimensionAttributes.includes(attr.attributeName)
      );
  
      // Update selectedValues for all dimension attributes
      const updatedSelectedValues = { ...selectedValues };
      allDimensionAttributes.forEach((attr: any) => {
        updatedSelectedValues[attr._id] = selectedUnit;
      });
      setSelectedValues(updatedSelectedValues);
  
      // Get current attributes
      const currentAttributes = [...values.attributes];
      
      // Process each dimension attribute
      allDimensionAttributes.forEach((attr: any) => {
        const existingAttributeIndex = currentAttributes.findIndex(
          (a: any) => a.attributeName === attr.attributeName
        );
  
        if (existingAttributeIndex >= 0) {
          // Update existing attribute
          currentAttributes[existingAttributeIndex] = {
            ...currentAttributes[existingAttributeIndex],
            unit: selectedUnit ? {
              _id: selectedUnit._id,
              name: selectedUnit.name,
            } : null,
          };
        } else {
          // Add new attribute if it doesn't exist
          currentAttributes.push({
            attributeName: attr.attributeName,
            value: "", // Empty value by default
            unit: selectedUnit ? {
              _id: selectedUnit._id,
              name: selectedUnit.name,
            } : null,
          });
        }
      });
  
      // Update the form values
      setFieldValue("attributes", currentAttributes);
    }
  }; */
  const handleDimensionsUnitChange = (attributeId: any, unitIndex: any, e: any) => {
    // First handle the normal unit change
    handleFirstSelectChange(attributeId, unitIndex)(e);

    // Check if this is a Dimensions group attribute
    const dimensionAttributes = ['Width', 'Depth', 'Height'];
    const currentAttribute = values.subcategory[0].supportedAttributes.find(
      (attr: any) => attr._id === attributeId
    );

    if (currentAttribute && dimensionAttributes.includes(currentAttribute.attributeName)) {
      // Get the selected unit
      const selectedUnit = values.subcategory[0].supportedAttributes.find(
        (attribute: any) => attribute._id === attributeId
      ).supportedUnits[unitIndex];

      // Find all dimension attributes
      const allDimensionAttributes = values.subcategory[0].supportedAttributes.filter(
        (attr: any) => dimensionAttributes.includes(attr.attributeName)
      );

      // Update selectedValues for all dimension attributes
      const updatedSelectedValues = { ...selectedValues };
      allDimensionAttributes.forEach((attr: any) => {
        updatedSelectedValues[attr._id] = selectedUnit;
      });
      setSelectedValues(updatedSelectedValues);

      // Get current attributes
      const currentAttributes = [...values.attributes];

      // Process each dimension attribute
      allDimensionAttributes.forEach((attr: any) => {
        const existingAttributeIndex = currentAttributes.findIndex(
          (a: any) => a.attributeName === attr.attributeName
        );

        if (existingAttributeIndex >= 0) {
          // Update existing attribute - preserve the value, only update the unit
          currentAttributes[existingAttributeIndex] = {
            ...currentAttributes[existingAttributeIndex],
            unit: selectedUnit ? {
              _id: selectedUnit._id,
              name: selectedUnit.name,
            } : null,
          };
        } else {
          // Add new attribute if it doesn't exist
          currentAttributes.push({
            attributeName: attr.attributeName,
            value: "", // Empty value by default
            unit: selectedUnit ? {
              _id: selectedUnit._id,
              name: selectedUnit.name,
            } : null,
          });
        }
      });

      // Update the form values
      setFieldValue("attributes", currentAttributes);
    }
  };


  /* const handleSecondSelectChange =
      (attributeId: any, unit: any) => (e: any) => {
        console.log(e);
        let attributeObject: any = {};
        if (typeof e === "object") {
          attributeObject = e;
        } else if (typeof e === "string") {
          attributeObject = {
            value: e,
            _id: Date.now(),
          };
        }
  
        // Check if value is being removed (empty string)
        const isValueRemoved = attributeObject?.value === "";
        console.log(isValueRemoved);
        const updatedAttributes = values.attributes.map((attribute: any) => {
          if (attribute.attributeName === attributeId) {
            return {
              ...attribute,
              value: attributeObject?.value,
              unit: isValueRemoved ? null : {
                _id: unit?._id,
                name: unit?.name,
              }, 
            };
          }
          return attribute;
        });
  
        const attributeExists = updatedAttributes.some(
          (attribute: any) => attribute.attributeName === attributeId
        );
  
        if (!attributeExists && !isValueRemoved) {
          updatedAttributes.push({
            attributeName: attributeId,
            value: attributeObject?.value,
            unit: {
              _id: unit._id,
              name: unit.name,
            },
          });
        }
  
        setFieldValue("attributes", updatedAttributes);
      }; */

  /* const handleSecondSelectChange =
  (attributeId: any, unit: any) => (e: any) => {
    let attributeObject: any = {};
    if (typeof e === "object") {
      attributeObject = e;
    } else if (typeof e === "string") {
      attributeObject = {
        value: e,
        _id: Date.now(),
      };
    }

    // Check if this is a Dimensions attribute (Width, Depth, Height)
    const isDimensionAttribute = ['Width', 'Depth', 'Height'].includes(attributeId);
    const dimensionAttributes = ['Width', 'Depth', 'Height'];
    
    let updatedSelectedValues = { ...selectedValues };
    let updatedAttributes = [...values.attributes];
    
    if (isDimensionAttribute) {
      // Process all dimension attributes
      dimensionAttributes.forEach((dimAttrName) => {
        const dimAttribute = values.subcategory[0].supportedAttributes.find(
          (attr: any) => attr.attributeName === dimAttrName
        );
         console.log( values.subcategory[0].supportedAttributes);
        if (dimAttribute) {
          // Get the first available unit for this attribute
          const firstUnit = dimAttribute.supportedUnits[0];
         
          // Update selectedValues for this attribute
          updatedSelectedValues[dimAttribute._id] = firstUnit;

          // Find or create the attribute in updatedAttributes
          const existingAttrIndex = updatedAttributes.findIndex(
            (attr: any) => attr.attributeName === dimAttrName
          );

          if (existingAttrIndex >= 0) {
            // Update existing attribute
            updatedAttributes[existingAttrIndex] = {
              ...updatedAttributes[existingAttrIndex],
              unit: {
                _id: firstUnit._id,
                name: firstUnit.name,
              },
            };
          } else {
            // Add new attribute if it doesn't exist
            updatedAttributes.push({
              attributeName: dimAttrName,
              value: dimAttrName === attributeId ? attributeObject?.value : "",
              unit: {
                _id: firstUnit._id,
                name: firstUnit.name,
              },
            });
          }
        }
      });

      // Update the selected values state
      setSelectedValues(updatedSelectedValues);
    } else {
      // Non-dimension attribute - proceed with normal update
      const isValueRemoved = attributeObject?.value === "";
      
      updatedAttributes = values.attributes.map((attribute: any) => {
        if (attribute.attributeName === attributeId) {
          return {
            ...attribute,
            value: attributeObject?.value,
            unit: isValueRemoved ? null : {
              _id: unit?._id,
              name: unit?.name,
            }, 
          };
        }
        return attribute;
      });

      const attributeExists = updatedAttributes.some(
        (attribute: any) => attribute.attributeName === attributeId
      );

      if (!attributeExists && !isValueRemoved) {
        updatedAttributes.push({
          attributeName: attributeId,
          value: attributeObject?.value,
          unit: {
            _id: unit._id,
            name: unit.name,
          },
        });
      }
    }

    setFieldValue("attributes", updatedAttributes);
  }; */

  const handleSecondSelectChange =
    (attributeId: any, unit: any) => (e: any) => {
      let attributeObject: any = {};
      if (typeof e === "object") {
        attributeObject = e;
      } else if (typeof e === "string") {
        attributeObject = {
          value: e,
          _id: Date.now(),
        };
      }
      // Check if this is a Dimensions attribute (Width, Depth, Height)
      const isDimensionAttribute = ['Width', 'Depth', 'Height'].includes(attributeId);
      const dimensionAttributes = ['Width', 'Depth', 'Height'];

      let updatedSelectedValues = { ...selectedValues };
      let updatedAttributes = [...values.attributes];

      if (isDimensionAttribute) {
        // Process all dimension attributes
        dimensionAttributes.forEach((dimAttrName) => {
          const dimAttribute = values.subcategory[0].supportedAttributes.find(
            (attr: any) => attr.attributeName === dimAttrName
          );

          if (dimAttribute) {

            // Get the first available unit for this attribute
            const firstUnit = unit || dimAttribute.supportedUnits[0];

            // Update selectedValues for this attribute
            updatedSelectedValues[dimAttribute._id] = firstUnit;

            // Find or create the attribute in updatedAttributes
            const existingAttrIndex = updatedAttributes.findIndex(
              (attr: any) => attr.attributeName === dimAttrName
            );

            let existingUnitVal: any = {};
            if (updatedAttributes[existingAttrIndex] && updatedAttributes[existingAttrIndex].unit) {
              existingUnitVal._id = updatedAttributes[existingAttrIndex].unit._id;
              existingUnitVal.name = updatedAttributes[existingAttrIndex].unit.name;
            } else {
              existingUnitVal = {
                _id: firstUnit._id,
                name: firstUnit.name,
              };
            }

            if (existingAttrIndex >= 0) {

              // Update existing attribute - preserve the value, update the unit to first unit
              updatedAttributes[existingAttrIndex] = {
                ...updatedAttributes[existingAttrIndex],
                value: dimAttrName === attributeId ? attributeObject?.value : updatedAttributes[existingAttrIndex]?.value,
                unit: existingUnitVal,
              };
            } else {
              // Add new attribute if it doesn't exist
              updatedAttributes.push({
                attributeName: dimAttrName,
                value: dimAttrName === attributeId ? attributeObject?.value : "",
                unit: existingUnitVal,
              });
            }
          }
        });

        // Update the selected values state
        setSelectedValues(updatedSelectedValues);
      } else {
        // Non-dimension attribute - proceed with normal update
        updatedAttributes = values.attributes.map((attribute: any) => {
          if (attribute.attributeName === attributeId) {
            return {
              ...attribute,
              value: attributeObject?.value,
              unit: {
                _id: unit?._id,
                name: unit?.name,
              },
            };
          }
          return attribute;
        });

        const attributeExists = updatedAttributes.some(
          (attribute: any) => attribute.attributeName === attributeId
        );

        if (!attributeExists) {
          updatedAttributes.push({
            attributeName: attributeId,
            value: attributeObject?.value,
            unit: {
              _id: unit._id,
              name: unit.name,
            },
          });
        }
      }

      setFieldValue("attributes", updatedAttributes);
    };

  const handleSecondSelectChangeFromSource = (
    attributeId: any,
    unit: any,
    e: any
  ) => {

    let attributeObject: any = {};
    if (typeof e === "object") {
      attributeObject = e;
    } else if (typeof e === "string") {
      attributeObject = {
        value: e,
        _id: Date.now(),
      };
    }
    const updatedAttributes = values.attributes.map((attribute: any) => {
      if (attribute.attributeName === attributeId) {
        return {
          ...attribute,
          value: attributeObject?.value,
          unit: {
            _id: unit._id,
            name: unit.name,
          },
        };
      }
      return attribute;
    });

    const attributeExists = updatedAttributes.some(
      (attribute: any) => attribute.attributeName === attributeId
    );

    if (!attributeExists) {
      updatedAttributes.push({
        attributeName: attributeId,
        value: attributeObject?.value,
        unit: {
          _id: unit._id,
          name: unit.name,
        },
      });
    }

    setFieldValue("attributes", updatedAttributes);
  };

  return (
    <div className="container ms-1">
      <div className="row">
        <div className="col-md-8">
          <div className="card mb-5 mb-xl-10">
            <div className="card-header border-1 cursor-pointer">
              <div className="card-title m-0">
                <div
                  role={"button"}
                  className="btn btn-sm btn-light me-5"
                  onClick={() => navigate("/product")}
                >
                  <i className="fa-solid fa-arrow-left fs-2"></i>
                </div>
                <h3 className="fw-bolder m-0">
                  {isEdit ? "Edit" : "Add"} Product
                </h3>
              </div>
            </div>
            <div className="card-body p-9">
              <div className="row mb-6">
                <label className="col-lg-2 col-form-label required fw-bold fs-6">
                  Name
                </label>
                <div className="col-lg-10">
                  <input
                    disabled={isloading}
                    placeholder="Product Name"
                    {...getFieldProps("displayName")}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid": touched?.displayName && errors?.displayName,
                    })}
                    type="text"
                  />
                  {touched?.displayName && errors?.displayName && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.displayName}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/*<div className="input-group mb-3">
                  <label className="col-lg-2 col-form-label required fw-bold fs-6">
                    Name
                  </label>
                  <div className="col-lg-8">
                    <input
                      disabled={isloading}
                      placeholder="Product Name"
                      {...getFieldProps("productName")}
                      className={clsx("form-control bg-transparent", {
                        "is-invalid":
                          touched?.productName && errors?.productName,
                      })}
                      type="text"
                    />
                    {touched?.productName && errors?.productName && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">{errors?.productName}</span>
                        </div>
                      </div>
                    )}

                    <Multiselect
                      options={products}
                      style={style}
                      disable={isloading}
                      onSearch={(e) => handleSearchParams(e)}
                      customArrow={<CustomArrow />}
                      groupBy="sourceType"
                      customCloseIcon={<CustomCrossButton />}
                      selectionLimit={1}
                      // selectedValues={values.category}
                      displayValue={`title`}
                      placeholder="Select Product"
                      onSelect={async (e) => {
                        await setFieldValue("productName", e?.[`0`].name);
                        await setProductToScrape(e);
                        if (e?.[0].source === "icecat") {
                          const lenovoProduct = products.find(
                            (product: any) => product.source !== "icecat"
                          );
                          await setsecondarySourceToScrape([lenovoProduct]);
                        } else if (e[0].source !== "icecat") {
                          const icecatProduct = products.find(
                            (product: any) => product.source === "icecat"
                          );
                          await setsecondarySourceToScrape([icecatProduct]);
                        }

                        // await setsecondarySourceToScrape([products?.[0]]);
                        // setFieldTouched("category");
                      }}
                      onRemove={async (e) => {
                        await setFieldValue("productName", "");
                        // await setFieldValue("subcategory", []);
                        // setFieldTouched("category");
                      }}
                      selectedValueDecorator={(value: string, option: any) => {
                        return <CustomTooltip value={value} option={option} />;
                      }}
                      optionValueDecorator={(value: string, option: any) => {
                        return (
                          <div className="d-flex justify-content-between">
                            <span>{value}</span>
                            <span className="text-danger">
                              {`${option?.source}`.toLocaleUpperCase()}
                            </span>
                          </div>
                        );
                      }}
                    />
                  </div>
                  <span
                    className="input-group-text p-2"
                    id="basic-addon1"
                    style={{ cursor: "pointer", height: "45px" }}
                    onClick={() => handleScrapeProduct(values?.productName)}
                  >
                    {isScrapping ? (
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    ) : (
                      <span>
                        <img
                          alt="generate"
                          src={toAbsoluteUrl(
                            "/media/icons/duotune/arrows/arr066.svg"
                          )}
                          className="h-30px"
                        />
                      </span>
                    )}
                  </span>
                </div> */}
              </div>

              <div className="row mb-6">
                <label className="col-lg-2 col-form-label required fw-bold fs-6">
                  Brand
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Enter Brand"
                    disabled={isloading}
                    {...getFieldProps("brand")}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid": touched?.brand && errors?.brand,
                    })}
                    type="text"
                  />
                  {touched?.brand && errors?.brand && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.brand}</span>
                      </div>
                    </div>
                  )}
                </div>

                <label className="col-lg-2 col-form-label required fw-bold fs-6">
                  Model
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Enter model"
                    disabled={isloading}
                    {...getFieldProps("model")}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid": touched?.model && errors?.model,
                    })}
                    type="text"
                  />
                  {touched?.model && errors?.model && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.model}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="row mb-6">
                <label className="col-lg-2 col-form-label required fw-bold fs-6">
                  Model Number
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Enter Model Number"
                    disabled={isloading}
                    {...getFieldProps("modelNumber")}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid": touched?.modelNumber && errors?.modelNumber,
                    })}
                    type="text"
                  />
                  {touched?.modelNumber && errors?.modelNumber && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.modelNumber}</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* <label className="col-lg-2 col-form-label required fw-bold fs-6">
                  SKU
                </label>
                <div className="col-lg-4">
                  <input
                    placeholder="Enter SKU"
                    disabled={isloading}
                    {...getFieldProps("sku")}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid": touched?.sku && errors?.sku,
                    })}
                    type="text"
                  />
                  {touched?.sku && errors?.sku && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.sku}</span>
                      </div>
                    </div>
                  )}
                </div> */}
              </div>

              <div className="row mb-6">
                <label className="col-lg-2 col-form-label required fw-bold fs-7">
                  Description
                </label>
                <div className="col-lg-10">
                  <textarea
                    rows={4}
                    disabled={isloading}
                    autoComplete="off"
                    placeholder="Description"
                    {...getFieldProps("description")}
                    className="form-control bg-transparent"
                  />
                  {touched?.description && errors?.description && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.description}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="d-flex flex-column flex-md-row w-md-50 w-100 pe-md-9">
              <div className="d-flex flex-column flex-md-column w-md-100  ">
                <label className="form-label fs-6 fw-bolder text-dark">
                  Notes
                </label>
                <textarea
                  autoComplete="off"
                  placeholder="Notes"
                  {...getFieldProps("notes")}
                  className="form-control bg-transparent"
                />
              </div>
            
          </div> */}
          <div className="card mb-5 mb-xl-10">
            <div className="card-body">
              <div className="rounded border border-dotted border-primary border-4 p-4">
                <h5 className="fw-bolder mb-5">Images</h5>
                <DropBox
                  onChange={handleDropFiles}
                  multiple={true}
                  maxFiles={5}
                />
                <ImageGrid
                  images={values?.productImages}
                  handleDelete={handleDelete}
                  name="somname"
                />
                {touched?.productImages && errors?.productImages && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      <span role="alert">{errors?.productImages}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-10 mb-5">
            <div className="container p-0 m-0">
              <div className="row mb-5">
                <div className="col-md-12">
                  <label className="form-label fs-6 fw-bolder text-dark required ">
                    Category
                  </label>
                  <div onClick={() => setFieldTouched("category")}>
                    <Multiselect
                      options={allCategory}
                      style={style}
                      disable={isloading}
                      customArrow={<CustomArrow />}
                      customCloseIcon={<CustomCrossButton />}
                      selectionLimit={1}
                      selectedValues={values.category}
                      displayValue={"categoryName"}
                      placeholder="Select Category"
                      onSelect={async (e) => {
                        await setFieldValue("category", e);
                        setFieldTouched("category");
                      }}
                      onRemove={async (e) => {
                        await setFieldValue("category", e);
                        // await setFieldValue("subcategory", []);
                        setFieldTouched("category");
                      }}
                      selectedValueDecorator={(value: string, option: any) => {
                        return <CustomTooltip value={value} option={option} />;
                      }}
                    />
                  </div>
                  {touched?.category && errors?.category && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.category}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <label className="form-label fs-6 fw-bolder text-dark required ">
                  Sub Category
                </label>
                <div onClick={() => setFieldTouched("subcategory")}>
                  <Multiselect
                    options={values?.category?.[0]?.subcategory ?? []}
                    style={style}
                    displayValue={"subcategoryName"}
                    customArrow={<CustomArrow />}
                    customCloseIcon={<CustomCrossButton />}
                    selectionLimit={1}
                    disable={isloading}
                    selectedValues={values.subcategory}
                    placeholder="Select Subcategory"
                    selectedValueDecorator={(value: string, option: any) => {
                      return <CustomTooltip value={value} option={option} />;
                    }}
                    onSelect={async (e) => {
                      await setFieldValue("subcategory", e);
                      setFieldTouched("subcategory");
                    }}
                  // onRemove={async (e) => {
                  //   await setFieldValue("regions", e);
                  //   setFieldTouched("regions");
                  // }}
                  />
                </div>
                {touched?.subcategory && errors?.subcategory && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      <span role="alert">{errors?.subcategory}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* <div className="card p-10 mb-5">
            <div className="container p-0 m-0">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label fs-6 fw-bolder text-dark required ">
                    Sub Category
                  </label>
                  <div onClick={() => setFieldTouched("subcategory")}>
                    <TagBox
                      tags={values.subcategory}
                      handleNew={handleNewTag}
                      handleDelete={handleDeleteTag}
                      placeholder={"SubCategories"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="card p-10 mb-5">
            <div className="container p-0 m-0">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label fs-6 fw-bolder text-dark required ">
                    Region
                  </label>
                  <div onClick={() => setFieldTouched("regions")}>
                    <Multiselect
                      options={allRegions}
                      style={style}
                      disable={isloading}
                      customArrow={<CustomArrow />}
                      customCloseIcon={<CustomCrossButton />}
                      selectedValues={values.regions}
                      selectionLimit={1}
                      displayValue={"regionName"}
                      placeholder="Select Region"
                      onSelect={async (e) => {
                        await setFieldValue("regions", e);
                        setFieldTouched("regions");
                      }}
                      onRemove={async (e) => {
                        await setFieldValue("regions", e);
                        setFieldTouched("regions");
                      }}
                      selectedValueDecorator={(value: string, option: any) => {
                        return <CustomTooltip value={value} option={option} />;
                      }}
                    />
                  </div>
                  {touched?.regions && errors?.regions && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{errors?.regions}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card w-100 mb-5 mb-xl-10">
        <div className="card-body">
          {/* <div className="d-flex">
            <div className="col-lg-3">
              <h5 className="fw-bolder mb-5">Specifications</h5>
            </div>
            <div className="col-lg-2">
              <h5 className="fw-bolder mb-5">Unit</h5>
            </div>
            <div className="col-lg-2">
              <h5 className="fw-bolder mb-5">Value</h5>
            </div>
            <div className="col-lg-2">
              <h5 className="fw-bolder mb-5">Primary Source</h5>
            </div>
            <div className="col-lg-2">
              <h5 className="fw-bolder mb-5">Secondary Source </h5>
            </div>
            <div className="col-lg-2">
              <h5 className="fw-bolder mb-5">Chat-gpt </h5>
            </div>
          </div> */}
          <div className="legend-badge w-25">
            <div className="badge-dot " style={{
              backgroundColor: 'magenta',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              display: 'inline-block',
              marginRight: '6px'
            }}></div>
            <span className="badge-text">Value Updated By Master Model Attribute</span>
          </div>
          <table className="table">
            <thead>
              <tr className="d-flex">
                <th className="col-lg-3">
                  <h5 className="fw-bolder mb-5">Specifications</h5>
                </th>
                <th className="col-lg-2">
                  <h5 className="fw-bolder mb-5">Unit</h5>
                </th>
                <th className="col-lg-2">
                  <h5 className="fw-bolder mb-5">Value</h5>
                </th>
                <th className="col-lg-2">
                  <h5 className="fw-bolder mb-5">

                    {isScrapping ? (
                      <span>
                        {productToScrape?.[`0`]?.source ? `Primary(${productToScrape?.[`0`]?.source})` : `Primary Source`}

                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <span>
                        {productToScrape?.[`0`]?.source ? `Primary(${productToScrape?.[`0`]?.source})` : `Primary Source`}
                      </span>
                    )}
                  </h5>
                </th>
                <th className="col-lg-2">
                  <h5 className="fw-bolder mb-5">
                    {secondaryLoading ? (
                      <span>
                        {secondarySourceToScrape?.[`0`]?.source ? `Seocndary(${secondarySourceToScrape?.[`0`]?.source})` : `Secondary Source`}

                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <span>
                        {secondarySourceToScrape?.[`0`]?.source ? `Secondary(${secondarySourceToScrape?.[`0`]?.source})` : `Secondary Source`}
                      </span>
                    )}
                  </h5>
                </th>
                <th className="col-lg-2">

                  <h5 className="fw-bolder mb-5">
                    {ternaryLoading ? (
                      <span>
                        {`Open-AI`}

                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <span>
                        {`Open-AI`}
                      </span>
                    )}
                  </h5>

                </th>
              </tr>
            </thead>
            <tbody>
              {values &&
                values.subcategory &&
                values.regions &&
                values.regions[0] &&
                values.subcategory[0] && (
                  (() => {
                    const attributeGroups = {
                      'Power': [
                        'AC adapter power',
                        'Charging port type',
                        'USB-C PD',
                        'USB-C Voltage',
                        'AC input voltage',
                        'Legacy AC adapter tip size',
                        'Legacy Power Tip',
                        'Charging Protocols'
                      ],
                      'Display': [
                        'Display diagonal',
                        'Display resolution',
                        'ASPECT RATIO',
                        'Touchscreen'
                      ],
                      'Video Ports': [
                        'DisplayPorts quantity',
                        'HDMI ports quantity',
                        'DVI port'
                      ],
                      'Cable Locks': [
                        'Cable lock slot',
                        'Cable lock slot type (1)',
                        'Cable lock slot type (2)',
                        'Universal'
                      ],
                      'Type-A ports': [
                        'Number of USB-A Ports',
                        'USB 3.2 GEN 2 (3.1 GEN 2) TYPE-A PORTS QUANTITY',
                        'USB 3.2 Gen 1 (3.1 Gen 1) Type-A ports quantity ',
                        'USB 2.0 Type-A Ports Quantity',
                        'USB 2.0 ports quantity',
                        'USB-A Upstream Communication Protocols'
                      ],
                      'Type-C Ports': [
                        'Number of USB-C Ports',
                        'USB 2.0 Type-C Ports',
                        'USB 3.2 GEN 1 (3.1 GEN 1) TYPE-C PORTS QUANTITY',
                        'USB 3.2 Gen 2 (3.1 Gen 2) Type-C ports quantity',
                        'DisplayPort Alt Mode Type-C Ports',
                        'Thunderbolt 3 Type-C Ports',
                        'Thunderbolt 4 Type-C Ports',
                        'USB4 Type-C ports',
                        'Thunderbolt 5 Type C Ports',
                        'USB-C Upstream Communication Protocols'
                      ],
                      'Audio Ports': [
                        'Combo headphone/mic port'
                      ],
                      'Communication': [
                        'Ethernet LAN (RJ-45) ports',
                        'Wi-Fi',
                        'Wi-Fi standards',
                        'Bluetooth'
                      ],
                      'Dimensions': [
                        'Width',
                        'Depth',
                        'Height',
                        'Weight'
                      ]
                    };

                    // Get all defined attribute names
                    const allDefinedAttributes = Object.values(attributeGroups).flat();

                    // Get grouped attributes
                    let groupedAttributes = Object.entries(attributeGroups).map(([groupName, attributeNames]) => ({
                      groupName,
                      attributes: values.subcategory[0].supportedAttributes.filter((attribute: any) =>
                        attributeNames.includes(attribute.attributeName)
                      )
                    }));

                    // Get attributes that don't belong to any group
                    const otherAttributes = values.subcategory[0].supportedAttributes.filter(
                      (attribute: any) => !allDefinedAttributes.includes(attribute.attributeName)
                    );

                    // Add Others group if there are ungrouped attributes
                    if (otherAttributes.length > 0) {
                      groupedAttributes.push({
                        groupName: 'Others',
                        attributes: otherAttributes
                      });
                    }

                    // Filter out empty groups
                    groupedAttributes = groupedAttributes.filter(group => group.attributes.length > 0);

                    return groupedAttributes.map(({ groupName, attributes }) => (
                      <tr key={groupName}>
                        <td colSpan={6}>
                          <div className="border-1 border-gray-300 border-dashed rounded-lg p-4 mb-4">
                            <h3 className="fw-bold text-lg mb-4">{groupName}</h3>
                            <table className="w-full">
                              <tbody>
                                {attributes.map((attribute: any) => {
                                  //const selectedUnit = selectedValues[attribute._id];
                                  const selectedUnit = (selectedValues[attribute._id]) ? selectedValues[attribute._id] : "";
                                  const supportedValues = selectedUnit ? selectedUnit.supportedValues : [];
                                  let filteredResult = values?.attributes?.filter(
                                    ({ attributeName }: { attributeName: any }) =>
                                      attributeName === attribute.attributeName
                                  );

                                  // Check if current attribute has updateByMasterModel: true
                                  const hasUpdateByMasterModel = filteredResult.length > 0 && filteredResult[0]?.updateByMasterModel === true;

                                  // Debug: Console log to check the data
                                  if (attribute.attributeName === 'Front camera resolution') {
                                    console.log('Front camera resolution attribute:', filteredResult[0]);
                                    console.log('hasUpdateByMasterModel:', hasUpdateByMasterModel);
                                  }

                                  if (filteredResult.length > 0) {
                                    const valueToAdd = filteredResult?.[0]?.value;
                                    const valueExists = supportedValues.some(
                                      (supportedValue: any) => supportedValue.value === valueToAdd
                                    );

                                    if (!valueExists) {
                                      supportedValues.push({
                                        value: valueToAdd,
                                        _id: Date.now(),
                                      });
                                    }
                                  }

                                  const selectedValue = supportedValues.filter(
                                    (supportedValue: any) => supportedValue.value === filteredResult?.[0]?.value
                                  );

                                  const supportedUnitsFrist = attribute?.supportedUnits
                                    .filter((unit: any) =>
                                      unit.regions.includes(
                                        values?.regions?.[0]?.id ||
                                        values?.regions?.[0]?._id ||
                                        ""
                                      )
                                    );

                                  return (
                                    <tr key={attribute._id} className="mb-8">
                                      <td className="w-1/6 px-2 py-2">
                                        <label className="required fw-bold fs-6">
                                          {attribute?.attributeName}
                                        </label>
                                      </td>
                                      <td className="w-1/6 px-2 py-2">
                                        <select
                                          value={selectedUnit ? JSON.stringify(selectedUnit) : ""}
                                          disabled={isloading}
                                          className="form-select form-select-white w-full"
                                          onChange={(e) => {
                                            let parsedValue: any;
                                            try {
                                              parsedValue = JSON.parse(e.target.value).name;
                                            } catch (error) {
                                              parsedValue = "";
                                            }

                                            if (['Width', 'Depth', 'Height'].includes(attribute?.attributeName)) {
                                              handleDimensionsUnitChange(
                                                attribute._id,
                                                attribute.supportedUnits.findIndex(
                                                  (unit: any) => unit.name === parsedValue
                                                ),
                                                e
                                              );
                                            } else {
                                              handleFirstSelectChange(
                                                attribute._id,
                                                attribute.supportedUnits.findIndex(
                                                  (unit: any) => unit.name === parsedValue
                                                )
                                              )(e);
                                            }
                                          }}
                                        >
                                          <option value={""}>Please choose one option</option>
                                          {attribute?.supportedUnits
                                            .filter((unit: any) =>
                                              unit.regions.includes(
                                                values?.regions?.[0]?.id ||
                                                values?.regions?.[0]?._id ||
                                                ""
                                              )
                                            )
                                            .map((option: any, index: any) => (
                                              <option
                                                key={index}
                                                value={JSON.stringify(option)}
                                              >
                                                {option.name}
                                              </option>
                                            ))}
                                        </select>
                                      </td>
                                      <td className="w-1/4 px-2 py-2">
                                        {hasUpdateByMasterModel ? (
                                          <div style={{
                                            color: '#ff00ff',
                                            fontWeight: 'bold',
                                            padding: '6px 12px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '0.375rem',
                                            backgroundColor: 'white',
                                            minHeight: '38px',
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}>
                                            {selectedValue?.[0]?.value || 'Select value'}
                                          </div>
                                        ) : (
                                          <SelectComponent
                                            options={supportedValues}
                                            selectedOption={selectedValue?.[0]?.value}
                                            selectedKey={"value"}
                                            onSelect={handleSecondSelectChange(
                                              attribute.attributeName,
                                              supportedUnitsFrist[0]
                                            )}
                                            onInputChange={handleSecondSelectChange(
                                              attribute.attributeName,
                                              supportedUnitsFrist[0]
                                            )}
                                          />
                                        )}
                                      </td>
                                      <td className="w-1/6 px-2 py-2">
                                        <div
                                          onClick={() =>
                                            handleSecondSelectChangeFromSource(
                                              attribute.attributeName,
                                              selectedUnit,
                                              primarySourceData?.filter(
                                                (data: any) =>
                                                  data?.attributeName === attribute?.attributeName
                                              )?.["0"]?.value
                                            )
                                          }
                                          className="d-flex alt-value cursor-pointer"
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontSize: "inherit",
                                            // paddingLeft: "25px",
                                            color: hasUpdateByMasterModel ? '#ff00ff' : 'inherit'
                                          }}
                                        >
                                          {primarySourceData?.length > 0 &&
                                            primarySourceData?.filter(
                                              (data: any) =>
                                                data?.attributeName === attribute?.attributeName
                                            )?.["0"]?.value}
                                        </div>
                                      </td>
                                      <td className="w-1/6 px-2 py-2">
                                        <div
                                          onClick={() =>
                                            handleSecondSelectChangeFromSource(
                                              attribute.attributeName,
                                              selectedUnit,
                                              secondarySourceData?.filter(
                                                (data: any) =>
                                                  data?.attributeName === attribute?.attributeName
                                              )?.["0"]?.value
                                            )
                                          }
                                          className="d-flex alt-value cursor-pointer"
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontSize: "inherit",
                                            // paddingLeft: "25px",
                                            color: hasUpdateByMasterModel ? '#ff00ff' : 'inherit'
                                          }}
                                        >
                                          {secondarySourceData?.length > 0 &&
                                            secondarySourceData?.filter(
                                              (data: any) =>
                                                data?.attributeName === attribute?.attributeName
                                            )?.["0"]?.value}
                                        </div>
                                      </td>
                                      <td className="w-1/6 px-2 py-2">
                                        <div
                                          onClick={() =>
                                            handleSecondSelectChangeFromSource(
                                              attribute.attributeName,
                                              selectedUnit,
                                              chatGptData?.filter(
                                                (data: any) =>
                                                  data?.attributeName === attribute?.attributeName
                                              )?.["0"]?.value
                                            )
                                          }
                                          className="d-flex alt-value cursor-pointer"
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontSize: "inherit",
                                            // paddingLeft: "25px",
                                            color: hasUpdateByMasterModel ? '#ff00ff' : 'inherit'
                                          }}
                                        >
                                          {chatGptData?.length > 0 &&
                                            chatGptData?.filter(
                                              (data: any) =>
                                                data?.attributeName === attribute?.attributeName
                                            )?.["0"]?.value}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    ));
                  })()
                )}
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
};

export default ProductForm;
